"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonStyle = void 0;
var ButtonStyle = {
  DESTRUCTIVE: 'destructive',
  DESTRUCTIVE_MINIMAL: 'destructive_minimal',
  POSITIVE: 'positive',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary'
};
exports.ButtonStyle = ButtonStyle;